import Chart from 'chart.js';
import Settings from '@engine/features/dashboard/chart/dashboard_chart_settings';
import Util from '@engine/features/dashboard/chart/dashboard_chart_utility';

function Bars() {
  var chart = null;

  function buildDataset(json) {
    var styles = {
      backgroundColor: 'rgba(34, 167, 230, 0.48)',
      borderColor: 'rgb(34, 167, 230)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(21,158,223,.52)',
      hoverBorderColor: 'rgb(34, 167, 230)'
    };
    var data = {
      datasets: [{
        label: 'Volume in ' + Util.currency(),
        backgroundColor: styles.backgroundColor,
        borderColor: styles.borderColor,
        borderWidth: styles.borderWidth,
        hoverBackgroundColor: styles.hoverBackgroundColor,
        hoverBorderColor: styles.hoverBorderColor,
        data: json
      }]
    };
    return data;
  }

  function options() {
    var scales = {
      xAxes: [{
        type: 'time',
        time: {
          unit: 'day',
          tooltipFormat: Settings.LABEL_FORMAT
        },
        gridLines: {
          display: false
        },
        offset: true
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function callback(value) {
            return Util.formatVolume(value);
          }
        }
      }]
    };
    var tooltips = {
      position: 'nearest',
      xPadding: 10,
      yPadding: 10,
      callbacks: {
        label: function label(tooltip) {
          return ' Volume: ' + Util.formatVolume(tooltip.yLabel);
        }
      }
    };
    var settings = {
      maintainAspectRatio: false,
      scales: scales,
      tooltips: tooltips
    };
    return settings;
  }

  function create(dataset) {
    var context = $('#dashboard-chart');
    chart = new Chart(context, {
      type: 'bar',
      data: buildDataset(dataset),
      options: options()
    });
  }

  function forceUpdate(dataset) {
    chart.data.datasets[0].data = buildDataset(dataset).datasets[0].data;
    chart.data.datasets[0].label = buildDataset(dataset).datasets[0].label;
    chart.update();
  }

  return {
    create: create,
    forceUpdate: forceUpdate
  };
}

export default Bars();